/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.adminModule')
  .controller('AdminController', [
    '$filter',
    '$log',
    '$modal',
    '$q',
    'maintenanceAlert',
    'Restangular',
    'BulbAuthService',
    'BulbBusyService',
    'BulbModalService',
    '_',
    AdminController,
  ]);

function AdminController(
  $filter,
  $log,
  $modal,
  $q,
  maintenanceAlert,
  Restangular,
  BulbAuthService,
  BulbBusyService,
  BulbModalService,
  _,
) {
  const that = this;

  this.sitemapStatus = '';
  this.emailReportStatus = '';
  this.reportEmail = '';
  this.foundAccounts = '';
  this.searchAccounts = '';
  this.searchedFor = '';
  this.maintenanceMessage = '';
  this.maintenanceExample = '';
  this.currentMaintenaceAlert = '';
  this.maintenanceBeginsInput = '';
  this.organizations = null;
  this.indexingStatus = '';
  this.indexDuration = '';
  this.indexedBeforeDate = null;
  this.indexAll = false;

  if (maintenanceAlert && maintenanceAlert.date) {
    // Store the current alert in case of error.
    this.currentMaintenaceAlert = $filter('date')(new Date(maintenanceAlert.date), 'yyyy-MM-dd HH:mm');
    // The maintenance input shows the current alert setting.
    this.maintenanceBeginsInput = this.currentMaintenaceAlert;
  }

  // Round current time to the next multiple of 5 minutes at :00 seconds for the starting setting
  // and to display as an example to ease setting the value.
  const coeff = 1000 * 60 * 5;
  const roundedDate = new Date(Math.ceil(new Date().getTime() / coeff) * coeff);
  this.maintenanceExample = $filter('date')(roundedDate, 'yyyy-MM-dd HH:mm');

  this.isDefaultEmail = function (emailToCompare) {
    if (emailToCompare.email === BulbAuthService.currentUser.defaultEmail.email) {
      return true;
    }
    return false;
  };

  this.findAccounts = function () {
    that.foundAccounts = '';
    Restangular.all('admin/accounts').getList({ search: that.searchAccounts }).then((data) => {
      that.searchedFor = that.searchAccounts;
      that.foundAccounts = data;
    }, (error) => {
      $log.debug(`error is ${angular.toJson(error)}`);
    });

    // Also make sure we have the organizations list populated so we can access it for displayNames:
    that.fetchOrgs();
  };

  /*
  * @returns {boolean} if an account is part of an organization
  * */
  this.isOrganizationMember = function (account) {
    return _.countBy(account.groupMemberships, 'type').ORGANIZATION > 0;
  };

  this.setMaintenanceBegins = function () {
    that.maintenanceMessage = 'Attempting to set the maintenance begins.';
    try {
      // Firefox doesn't support a date in the format 'yyyy-MM-dd HH:mm'. Replace the dashes with slashes first.
      const dateString = new Date(that.maintenanceBeginsInput.replace(/-/g, '/'));
      Restangular.all('admin/set_maintenance_alert').post({ dateMS: dateString.getTime() }).then((data) => {
        if (data.date) {
          that.currentMaintenaceAlert = $filter('date')(new Date(data.date), 'yyyy-MM-dd HH:mm');
          // The maintenance input shows the current alert setting.
          that.maintenanceBeginsInput = that.currentMaintenaceAlert;
          that.maintenanceMessage = '';
        }
      }, (error) => {
        that.maintenanceMessage = 'Set maintenance alert failed. Error logged to console.';
        if (error.data) {
          if (error.data.developerMessage) {
            that.maintenanceMessage = error.data.developerMessage;
          }
        }
        $log.debug(`error is ${angular.toJson(error)}`);
      });
    } catch (error) {
      that.maintenanceMessage = 'Invalid maintenance begins value.';
    }
  };

  this.deleteMaintenanceBegins = function () {
    that.maintenanceMessage = 'Attempting to delete the maintenance begins.';
    Restangular.one('admin/delete_maintenance_alert').remove().then((data) => {
      that.currentMaintenaceAlert = '';
      that.maintenanceMessage = '';
    }, (error) => {
      that.maintenanceMessage = 'Delete maintenance alert failed. Error logged to console.';
      $log.debug(`error is ${angular.toJson(error)}`);
    });
    // The maintenance input shows the current alert setting.
    that.maintenanceBeginsInput = that.currentMaintenaceAlert;
  };

  this.createSitemap = function () {
    that.sitemapStatus = 'Attempting to create a sitemap.';
    Restangular.one('admin/create_sitemap').post().then((data) => {
      that.sitemapStatus = 'Sitemap created.';
    }, (error) => {
      that.sitemapStatus = 'Sitemap creation failed. Error logged to console.';
      $log.debug(`error is ${angular.toJson(error)}`);
    });
  };

  this.signInAs = function (username) {
    BulbAuthService.adminSignInAs(username);
  };

  this.fetchOrgs = function () {
    if (that.organizations === null) {
      return BulbBusyService.showBusyDuring(
        Restangular.all('organizations').getList()
          .then((organizations) => {
            // Sort organizations alphabetically.
            that.organizations = organizations.plain().sort((a, b) => a.displayName.toUpperCase().localeCompare(b.displayName.toUpperCase()));
          }),
      );
    }
    return that.organizations;
  };

  this.findOrganization = function (id) {
    return that.organizations.find((orgObj) => orgObj.id === id);
  };

  this.editOrgs = function (account) {
    $q.when(that.fetchOrgs(), () => {
      that.showOrgModal(account);
    });
  };

  this.setUserEnabled = function (account) {
    BulbAuthService.setUserEnabled(account.id, account.enabled)
      .then((modifiedAccount) => {
        account.enabled = modifiedAccount.enabled;
      })
      .catch((error) => {
        const modalOptions = {
          titleCode: 'admin_user_enable_error_title',
          bodyText: `admin_user_enable_error_message${error}`,
          showOkButton: true,
          showCancelButton: false,
        };
        BulbModalService.show(modalOptions);
      });
  };

  this.toggleSuspiciousAccount = function (account) {
    account.suspiciousAccount = !account.suspiciousAccount;
    return Restangular.one('admin/accounts', account.id)
      .customPOST({ suspiciousAccount: account.suspiciousAccount }, 'suspiciousAccount');
  };

  this.showOrgModal = function (account) {
    const modalInstance = $modal.open({
      templateUrl: 'ajs/admin/orgmodal.html',
      controller: 'OrgModalController as orgModalCtrl',
      resolve: {
        account: function acc() {
          return account;
        },
        organizations: function organizations() {
          return that.organizations;
        },
      },
    });

    modalInstance.result.then((savedAccount) => {
      // The modal was closed rather than dismissed, so we have changed both the account and organization:

      // Update account with server response.
      that.foundAccounts[that.foundAccounts.findIndex((account) => account.id === savedAccount.id)] = savedAccount;
    });
  };

  /**
   * This function is used to get the size of current storage progress bar.
   */
  this.progressBarValue = function (account) {
    const storageFeature = account.features.StorageFeature;
    return (storageFeature.currentUsedStorageBytes > storageFeature.maxStorageBytes)
      ? storageFeature.maxStorageBytes : storageFeature.currentUsedStorageBytes;
  };
}
